import {z} from 'zod';

import {reportFiltersSchema} from './ReportFiltersSchema';

export const countsByMonthSchema = z.object({
  month: z.string(),
  orderCount: z.number(),
  caseCount: z.number(),
});

export type CountsByMonth = z.infer<typeof countsByMonthSchema>;

export const countsSummarySchema = countsByMonthSchema.omit({month: true});

export type CountsSummary = z.infer<typeof countsSummarySchema>;

export const countsByMonthResponseSchema = z.object({
  data: z.array(countsByMonthSchema),
  summary: countsSummarySchema,
  filters: reportFiltersSchema,
});

export type CountsByMonthResponse = z.infer<typeof countsByMonthResponseSchema>;
